import React from 'react';
import formatMessage from 'format-message';
import PageTitle from '../../components/common/page-title';

const AccountHeader = () =>
  <PageTitle title={formatMessage('Admin')} />
;

export default AccountHeader;
